<template>
  <img
    src="../../assets/images/home-illustration.png"
    aria-hidden="true"
    class="absolute -bottom-10 right-0 hidden w-[350px] transition-all md:block lg:w-[400px]"
    alt=""
  >
</template>
